// custom context for tutorial feature. 
// serves as the single source of truth for the tutorial state, can add Typescript types here in the future.

import { useContext } from 'react';
import { TutorialContext } from './TutorialContext';

export const useTutorial = () => {
  const context = useContext(TutorialContext);
  if (!context) {
    throw new Error('useTutorial must be used within TutorialProvider');
  }
  return context;
};